import React, { useState, useCallback, useMemo, useContext } from 'react';
import useFields from '@ubeya/shared/hooks/account/useFields';
import { EMPLOYEE_FIELD_LEVEL, formatLevelOption } from '../../../utils/employee';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

// name/options override the mappedFields lookup for filters that aren't account fields (extraFilters)
const FieldsFilter = ({
  id: fieldId,
  name,
  options,
  defaultValue,
  handleClose,
  onApply,
  search,
  onChange,
  hideLayout = false
}) => {
  const { mappedFields } = useFields();
  const [values, setValues] = useState(defaultValue || []);
  const { t } = useContext(ConfigContext);

  const fieldName = name ?? mappedFields?.[fieldId]?.name;
  const fieldOptions = useMemo(() => options ?? mappedFields?.[fieldId]?.options ?? [], [
    options,
    mappedFields,
    fieldId
  ]);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(
    () =>
      search
        ? fieldOptions.filter(
            ({ title }) =>
              t(fieldName ?? '')
                .toLowerCase()
                .includes(search.toLowerCase()) || t(title).toLowerCase().includes(search.toLowerCase())
          )
        : fieldOptions,
    [fieldName, fieldOptions, search, t]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout name={fieldName} handleClose={handleClose} onApply={() => onApply(values)} hideLayout={hideLayout}>
      {filteredOptions.map(({ id, title }) => (
        <DropDown.Item key={id}>
          <CheckBox
            name={`${fieldId}-${id}`}
            value={values.includes(id)}
            label={fieldId === EMPLOYEE_FIELD_LEVEL ? formatLevelOption({ t, level: title }) : t(title)}
            onChange={() => handleChange(id)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default FieldsFilter;
